import { permissionScoreData } from '../const';
import { calcScorePermission } from '../providers/permissionProvider';
import { CalcScorePermissionType, PermissionCombinationType } from '../types';

const bufferScorePermission: Partial<{ [key in PermissionCombinationType]: CalcScorePermissionType }> = {};

const accessCheck = (
    permissions: Set<number>,
    accessFor: PermissionCombinationType[],
    isOwner?: boolean,
    isAssignee?: boolean,
) => {
    let isMasterAccess = false;
    let isOwnerAccess = false;
    let isAssigneeAccess = false;

    const accessAllow = !!accessFor.filter((permission) => {
        bufferScorePermission[permission] ??= calcScorePermission(permission);

        if (permissions.has(bufferScorePermission[permission]!.totalScore)) {
            switch (bufferScorePermission[permission]!.scoreType) {
                case 0:
                case permissionScoreData.type['all']:
                    isMasterAccess = true;
                    break;
                case permissionScoreData.type['owner']:
                    isOwnerAccess = true;
                    break;
                case permissionScoreData.type['assignee']:
                    isAssigneeAccess = true;
                    break;
            }

            return true;
        }

        return false;
    }).length;

    if (!isMasterAccess && (isOwner !== undefined || isAssignee !== undefined)) {
        return accessAllow && ((isOwner && isOwnerAccess) || (isAssignee && isAssigneeAccess) || false);
    }

    return accessAllow;
};

export default accessCheck;
